import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import get from 'lodash/get'
import set from 'lodash/set'
import findIndex from 'lodash/findIndex'
import { Container } from 'reactstrap'
import Content from '../../components/timesheet/tab-content'
import withLayout from '../../helpers/withLayout'
import Tab from '../../components/timesheet/tab'
import metrolendarHelper from '../../components/timesheet/helpers/date'
import { generateButton } from '../../components/timesheet/helpers/button'
import * as timesheetHelper from '../../components/timesheet/helpers/timesheet'
import { AddProjectForm } from '../../components/timesheet/form/add-project'
import { CopyTimesheetForm } from '../../components/timesheet/form/copy-timesheet'
import { SubmitTimesheetForm } from '../../components/timesheet/form/submit-timesheet'
import FillHoursForm from '../../components/timesheet/form/fill-hours'
import CustomModalMessage from '../../components/modal-message'
import Manual from '../../components/timesheet/helpers/manual'
import moment from '../../lib/moment.js'
import {
  authAction,
  modalAction,
  timesheetAction,
  leaveTypeAction,
} from './../../actions/'
import {
  authSelector,
  modalSelector,
  timesheetSelector,
  leaveTypeSelector,
} from './../../selectors'

class TimeSheetPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getMyTimesheetData.myTimesheet')) {
      const myTimesheet = get(nextProps, 'getMyTimesheetData.myTimesheet')
      let myTimesheetProjects = myTimesheet.timesheet.projects
      myTimesheetProjects = timesheetHelper.generateKeyProjects(myTimesheetProjects)
      myTimesheet.timesheet.projects = myTimesheetProjects
      set(tempState, 'myTimesheet', { ...myTimesheet })
      set(tempState, 'holidays', timesheetHelper.changeFormatDate(myTimesheet.holidays))
      set(tempState, 'leaveRequests', myTimesheet.leavesRequests)
      set(tempState, 'compensateRequests', myTimesheet.compensateRequests)
      if (get(myTimesheet, 'timesheet.sumHoursByDate.length' === 0)) {
        set(tempState, 'sumHoursByDate', timesheetHelper.generateSumHoursByDate(prevState.selectedDate))
      } else {
        set(tempState, 'sumHoursByDate', myTimesheet.timesheet.sumHoursByDate)
      }
      set(tempState, 'myProjects', myTimesheet.projects)
      set(tempState, 'maximumWorkingHoursPerDay', myTimesheet.maximumWorkingHoursPerDay)
      set(tempState, 'selectedDate', prevState.selectedDate)
      nextProps.resetGetMyTimesheet()
    }
    if (get(nextProps, 'getTimesheetsData.timesheets')) {
      const timesheets = get(nextProps, 'getTimesheetsData.timesheets')
      set(tempState, 'timesheets', timesheets)
      set(tempState, 'locations', timesheetHelper.createLocationList(timesheets.locations))
      set(tempState, 'projects', timesheets.projects)
      set(tempState, 'timesheetApprovals', timesheets.timesheetApprovals)
      nextProps.resetGetTimesheets()
    }
    if (get(nextProps, 'editTimesheetsData.timesheets')) {
      nextProps.showConfirm('editTimesheet', get(nextProps, 'editTimesheetsData.status'), get(nextProps, 'editTimesheetsData.message'))
      if (get(nextProps, 'editTimesheetsData.status') === 200) {
        set(tempState, 'isEdit', false)
        nextProps.getMyTimesheet(moment(prevState.selectedDate).format('YYYY-MM'), localStorage.getItem('access_token'))
      }
      nextProps.resetEditTimesheets()
    }
    if (get(nextProps, 'getInvalidInputData.invalidList') !== prevState.invalidList) {
      set(tempState, 'invalidList', get(nextProps, 'getInvalidInputData.invalidList'))
    }
    if (get(nextProps, 'getTimesheetByProjectsData.timesheets')) {
      set(tempState, 'timesheetByProjects', get(nextProps, 'getTimesheetByProjectsData.timesheets'))
      nextProps.resetGetTimesheetByProjects()
    }
    if (get(nextProps, 'submitTimesheetData.submittedTimesheet')) {
      nextProps.showConfirm('submitTimesheet', get(nextProps, 'submitTimesheetData.status'), get(nextProps, 'submitTimesheetData.message'))
      if (get(nextProps, 'submitTimesheetData.status') === 200) {
        nextProps.getMyTimesheet(moment(prevState.selectedDate).format('YYYY-MM'), localStorage.getItem('access_token'))
      }
      nextProps.resetSubmitTimesheet()
    }
    if (get(nextProps, 'getTimesheetStatusData.timesheetStatus')) {
      if (get(nextProps, 'getTimesheetStatusData.status') === 200) {
        set(tempState, 'timesheetStatus', get(nextProps, 'getTimesheetStatusData.timesheetStatus'))
      } else {
        nextProps.showConfirm('editTimesheet', get(nextProps, 'getTimesheetStatusData.status'), get(nextProps, 'getTimesheetStatusData.message'))
      }
      nextProps.resetGetTimesheetStatus()
    }
    if (get(nextProps, 'getTimesheetRequestData.timesheetRequest')) {
      if (get(nextProps, 'location.state.activeTab')) set(tempState, 'activeTab', get(nextProps, 'location.state.activeTab'))
      else set(tempState, 'activeTab', prevState.activeTab)
      set(tempState, 'timesheetRequest', get(nextProps, 'getTimesheetRequestData.timesheetRequest'))
      nextProps.resetGetTimesheetRequest()
    }
    if (get(nextProps, 'approveTimesheetData.responseTimesheet')) {
      const status = get(nextProps, 'approveTimesheetData.status')
      const message = get(nextProps, 'approveTimesheetData.message')
      nextProps.showConfirm('approveTimesheet', status, message)
      nextProps.getTimesheetRequest(get(nextProps, 'approveTimesheetData.responseTimesheet._id'), localStorage.getItem('access_token'))
      nextProps.getMyTimesheet(moment().format('YYYY-MM'), localStorage.getItem('access_token'))
      nextProps.getTimesheets(localStorage.getItem('access_token'))
      nextProps.resetApproveTimesheet()
    }
    if (get(nextProps, 'cancelTimesheetData.canceledTimesheet')) {
      const status = get(nextProps, 'cancelTimesheetData.status')
      const message = get(nextProps, 'cancelTimesheetData.message')
      nextProps.getTimesheetRequest(get(nextProps, 'cancelTimesheetData.canceledTimesheet._id'), localStorage.getItem('access_token'))
      nextProps.getTimesheetStatus(moment(prevState.dateStatus).format('YYYY-MM'), moment(prevState.dateStatus).format('YYYY-MM'), localStorage.getItem('access_token'))
      nextProps.showConfirm('editTimesheet', status, message)
      nextProps.resetCancelTimesheet()
    }
    if (get(nextProps, 'setRedirectData')) {
      set(tempState, 'redirect', get(nextProps, 'setRedirectData.redirect'))
    }
    if (get(nextProps, 'getLeaveTypeData') !== prevState.leaveTypes) {
      set(tempState, 'leaveTypes', get(nextProps, 'getLeaveTypeData'))
    }
    return tempState
  }

  state={
    isEdit: false,
    activeTab: 1,
    showAddProject: false,
    showFillHours: false,
    showCopyTimesheet: false,
    projects: [],
    selectedProject: [],
    selectedRadioAddProject: 1,
    selectedDate: moment(),
    dates: metrolendarHelper.getTableDates(moment(), 'month'),
    weekdates: metrolendarHelper.getTableWeekDates(moment()),
    approveDate: moment(),
  }

  componentDidMount() {
    if (get(this.props, 'location.pathname') === `/time_sheet/approval/${get(this.props, 'match.params.id')}`
    || get(this.props, 'location.pathname') === `/time_sheet/status/${get(this.props, 'match.params.id')}`) {
      this.props.getTimesheetRequest(get(this.props, 'match.params.id'), localStorage.getItem('access_token'))
    }
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getLeaveType(access_token)
    this.props.getMyTimesheet(moment().format('YYYY-MM'), access_token)
    this.props.getTimesheets(access_token)
  }

  setTotalHoursValue = (date, value) => {
    const { sumHoursByDate } = this.state
    sumHoursByDate[moment(date).format('YYYY-MM-DD')] = value
    this.setState({ sumHoursByDate })
  }

  toggleTab = (tab) => {
    this.setState({ activeTab: tab })
    if (get(this.props, 'location.pathname') === `/time_sheet/${this.state.activeTab === 3 ? 'status' : 'approval'}/${get(this.props, 'match.params.id')}`) {
      get(this.props, 'history').replace('/time_sheet', { header: 'Timesheet' })
    }
    const access_token = localStorage.getItem('access_token')
    switch (tab) {
      case 1: {
        if (this.state.myTimesheet === undefined) {
          this.props.getMyTimesheet(moment().format('YYYY-MM'), access_token)
          this.props.getTimesheets(access_token)
          return this.setState({ selectedDate: moment() })
        }
        return null
      }
      case 2: return this.setState({ selectedDateProjects: moment().subtract(1, 'month') })
      case 3: {
        if (this.state.timesheetStatus === undefined) {
          this.setState({ dateStatus: moment().subtract(1, 'month') })
          return this.props.getTimesheetStatus(moment().subtract(1, 'month').format('YYYY-MM'), moment().subtract(1, 'month').format('YYYY-MM'), access_token)
        }
        return null
      }
      default: return null
    }
  }

  clickRadioAddProject = (selected) => {
    this.setState({ selectedRadioAddProject: selected })
  }

  clickEdit = () => {
    this.setState({ isEdit: !this.state.isEdit })
  }

  clickCancel = () => {
    this.setState({ isEdit: !this.state.isEdit })
    if (this.state.isEdit) {
      this.props.resetInvalidInput()
      this.props.getMyTimesheet(moment(this.state.selectedDate).format('YYYY-MM'), localStorage.getItem('access_token'))
    }
  }

  addProject = () => {
    this.setState({
      showAddProject: !this.state.showAddProject,
      selectedProject: [],
      searchAddProject: '',
      selectedRadioAddProject: 1,
    })
  }

  deleteProject = (projectID) => {
    let { myTimesheet } = this.state
    const { maximumWorkingHoursPerDay, dates, invalidList } = this.state
    const index = findIndex(myTimesheet.timesheet.projects, { key: projectID })
    myTimesheet.timesheet.projects.splice(index, 1)
    if (myTimesheet.timesheet.projects.length > 0) {
      myTimesheet = timesheetHelper.reCalculateTotalHours(myTimesheet,
        maximumWorkingHoursPerDay, (time, value) => this.setTotalHoursValue(time.date, value),
        (newInvalidList) => this.props.setInvalidInput(newInvalidList), invalidList)
    } else this.setState({ sumHoursByDate: timesheetHelper.generateSumHoursByDate(dates) })
    this.setState({ myTimesheet })
  }

  copyTimesheet = () => {
    this.setState({ showCopyTimesheet: !this.state.showCopyTimesheet })
  }

  clickCopyButton = (type, sumHoursByDate, myTimesheet) => {
    switch (type) {
      case 'copy': {
        this.setState({ myTimesheet, sumHoursByDate })
        this.copyTimesheet()
        break
      }
      case 'cancel': {
        this.copyTimesheet()
        break
      }
      default:
        break
    }
  }

  addTask = (projectID) => {
    const { myTimesheet, selectedDate } = this.state
    const index = findIndex(myTimesheet.timesheet.projects, { key: projectID })
    myTimesheet.timesheet.projects[index].tasks = [
      ...myTimesheet.timesheet.projects[index].tasks,
      timesheetHelper.addTask(selectedDate),
    ]
    this.setState({ myTimesheet })
  }

  deleteTask = (projectID, taskID) => {
    let { myTimesheet } = this.state
    const { maximumWorkingHoursPerDay, dates, invalidList } = this.state
    const index = findIndex(myTimesheet.timesheet.projects, { key: projectID })
    if (myTimesheet.timesheet.projects[index].tasks.length > 1) {
      myTimesheet.timesheet.projects[index].tasks.splice(taskID, 1)
      if (myTimesheet.timesheet.projects.length > 0) {
        myTimesheet = timesheetHelper.reCalculateTotalHours(myTimesheet,
          maximumWorkingHoursPerDay, (time, value) => this.setTotalHoursValue(time.date, value),
          (newInvalidList) => this.props.setInvalidInput(newInvalidList), invalidList)
      } else this.setState({ sumHoursByDate: timesheetHelper.generateSumHoursByDate(dates) })
      this.setState({ myTimesheet })
    } else this.deleteProject(projectID)
  }

  editHour = (e, taskID, timeID, projectID, onBlur) => {
    if (e.target.value === '' && onBlur) e.target.value = 0
    const { myTimesheet } = this.state
    const index = findIndex(myTimesheet.timesheet.projects, { key: projectID })
    myTimesheet.timesheet.projects[index].tasks[taskID].times[timeID].hours = e.target.value
    this.setState({ myTimesheet })
    const date = myTimesheet.timesheet.projects[index].tasks[taskID].times[timeID].date
    this.calculateTotalHours(e, taskID, timeID, date)
  }

  calculateTotalHours = (e, taskID, timeID, date) => {
    const { myTimesheet, maximumWorkingHoursPerDay, invalidList } = this.state
    const exceed = timesheetHelper.calculateTotalHours(e, timeID, myTimesheet,
      maximumWorkingHoursPerDay, (value) => this.setTotalHoursValue(date, value))
    const newInvalidList = timesheetHelper.setInvalidInput(exceed, taskID, date, invalidList)
    this.props.setInvalidInput(newInvalidList)
  }

  applyFillHours = (projects) => {
    const { maximumWorkingHoursPerDay, invalidList } = this.state
    let { myTimesheet } = this.state
    myTimesheet.timesheet.projects = projects
    myTimesheet = timesheetHelper.reCalculateTotalHours(myTimesheet,
      maximumWorkingHoursPerDay, (time, value) => this.setTotalHoursValue(time.date, value),
      (newInvalidList) => this.props.setInvalidInput(newInvalidList), invalidList)
    this.setState({
      myTimesheet,
      showFillHours: !this.state.showFillHours,
    })
  }

  handleDate = (date) => {
    this.setState({
      dates: metrolendarHelper.getTableDates(moment(date), 'month'),
      weekdates: metrolendarHelper.getTableWeekDates(moment(date)),
      selectedDate: date,
      approveDate: date,
    })
    this.props.getMyTimesheet(moment(date).format('YYYY-MM'), localStorage.getItem('access_token'))
  }

  handleCheckboxAddProject = (e) => {
    let { selectedProject } = this.state
    const index = selectedProject.indexOf(e.target.id)
    if (index > -1) {
      selectedProject.splice(index, 1)
    } else selectedProject = [...this.state.selectedProject, e.target.id]
    this.setState({ selectedProject })
  }

  handleInputMyTimesheet = (field, data, projectID, taskID) => {
    const { myTimesheet } = this.state
    const index = findIndex(myTimesheet.timesheet.projects, { key: projectID })
    switch (field) {
      case 'approver_id': {
        myTimesheet.timesheet.projects[index].approver_id = data.value
        this.setState({ myTimesheet })
        break
      }
      case 'location_id': {
        myTimesheet.timesheet.projects[index].tasks[taskID].location_id = data.value
        this.setState({ myTimesheet })
        break
      }
      case 'task_name': {
        myTimesheet.timesheet.projects[index].tasks[taskID].task_name = data.target.value
        this.setState({ myTimesheet })
        break
      }
      default:
        break
    }
  }

  saveMyTimesheet = () => {
    const { myTimesheet, invalidList, leaveRequests, compensateRequests, holidays } = this.state
    if (invalidList.length > 0
      || timesheetHelper.checkInvalidApprover(myTimesheet.timesheet.projects)) {
      this.props.showConfirm('editTimesheet', 'Error', 'You have some invalid information. Please check and edit.')
      return
    }
    const payload = {
      projects: timesheetHelper.removeKeyProjects(
        timesheetHelper.removeEmptyTask(
          myTimesheet.timesheet.projects, leaveRequests, compensateRequests, holidays)),
      month: myTimesheet.timesheet.month,
    }
    this.props.editTimesheets(payload, localStorage.getItem('access_token'))
  }

  submitMyTimesheet = (type) => {
    switch (type) {
      case 'submit': {
        const { submitRemark, myTimesheet } = this.state
        const payload = { remark: submitRemark }
        this.props.submitTimesheet(myTimesheet.timesheet._id, payload, localStorage.getItem('access_token'))
        return this.setState({ showSubmitRemark: false, submitRemark: '' })
      }
      default:
        return this.setState({ showSubmitRemark: false, submitRemark: '' })
    }
  }

  discardTimesheet = (type) => {
    switch (type) {
      case 'cancel': return this.props.hideConfirm('discardTimesheet')
      case 'discard': {
        if (this.state.discardType === 'clickTab') {
          this.setState({ isEdit: !this.state.isEdit })
          this.toggleTab(this.state.discardValue)
        } else if (this.state.discardType === 'clickMonth') {
          this.setState({ isEdit: !this.state.isEdit })
          this.handleDate(this.state.discardValue)
        } else if (this.state.discardType === 'clickCancel') {
          this.clickCancel()
        }
        return this.props.hideConfirm('discardTimesheet')
      }
      default:
        return this.props.hideConfirm('discardTimesheet')
    }
  }

  handleDiscard = (type, value) => {
    switch (type) {
      case 'clickCancel': {
        this.setState({ discardType: 'clickCancel' })
        break
      }
      case 'clickTab': {
        this.setState({ discardType: 'clickTab', discardValue: value })
        break
      }
      case 'clickMonth': {
        this.setState({ discardType: 'clickMonth', discardValue: value })
        break
      }
      default: break
    }
    this.props.showConfirm('discardTimesheet', 'Discard', 'Are you sure you want to discard all changes ?')
  }

  clickButtonAddProject = (type) => {
    switch (type) {
      case 'add': {
        const { myTimesheet, projects, selectedProject, selectedDate, dates } = this.state
        const newProjects = timesheetHelper.addProject(selectedProject, projects,
          myTimesheet.timesheet, selectedDate)
        let sumHoursByDate = []
        if (myTimesheet.timesheet.projects.length === 0) {
          sumHoursByDate = timesheetHelper.generateSumHoursByDate(dates)
          this.setState({ sumHoursByDate })
        }
        myTimesheet.timesheet.projects = newProjects
        this.setState({ myTimesheet, selectedProject: [] })
        return this.addProject()
      }
      default: return this.addProject()
    }
  }

  handleInputTimesheetByProjects = (field, data) => {
    const access_token = localStorage.getItem('access_token')
    const { selectedIDProjects, selectedDateProjects } = this.state
    switch (field) {
      case 'select_project': {
        this.setState({ selectedIDProjects: data.value })
        if (data.value !== '') {
          this.props.getTimesheetByProjects(data.value, moment(selectedDateProjects, 'MM/YYYY').format('YYYY-MM'), access_token)
        }
        break
      }
      case 'select_today': {
        this.setState({
          selectedDateProjects: moment(),
          dates: metrolendarHelper.getTableDates(moment(), 'month'),
        })
        if (selectedIDProjects !== '') {
          this.props.getTimesheetByProjects(selectedIDProjects, moment().format('YYYY-MM'), access_token)
        }
        break
      }
      case 'select_date': {
        this.setState({
          selectedDateProjects: data,
          dates: metrolendarHelper.getTableDates(moment(data, 'MM/YYYY'), 'month'),
        })
        if (selectedIDProjects !== '') {
          this.props.getTimesheetByProjects(selectedIDProjects, moment(data, 'MM/YYYY').format('YYYY-MM'), access_token)
        }
        break
      }
      default: break
    }
  }

  handleInputTimesheetStatus = (field, data) => {
    const access_token = localStorage.getItem('access_token')
    const { dateStatus } = this.state
    switch (field) {
      case 'dateStatus': {
        this.setState({ dateStatus: data })
        return this.props.getTimesheetStatus(
          moment(dateStatus).startOf('month').format('YYYY-MM'),
          moment(dateStatus).endOf('month').format('YYYY-MM'),
          access_token)
      }
      case 'searchStatus': {
        return this.setState({ searchStatus: data })
      }
      default: return null
    }
  }

  handleInputTimesheetApproval = (field, data) => {
    switch (field) {
      case 'searchApproval': {
        this.setState({ searchApproval: data })
        break
      }
      default: break
    }
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) {
      return generateButton('success', () => {
        this.props.hideConfirm(confirmType)
        if (confirmType === 'approveTimesheet') get(this.props, 'history').replace({ pathname: '/inbox', state: { header: 'My Inbox' } })
      })
    } else if (confirmStatus === 'Discard') return generateButton('discard', (type) => this.discardTimesheet(type))
    else if (confirmStatus === 'Error') return generateButton('error', () => this.props.hideConfirm(confirmType))
    return null
  }

  render() {
    const {
      confirmType,
      confirmStatus,
      confirmMessage,
      isFetching,
    } = this.props
    const { redirect } = this.state
    if (redirect) {
      this.props.getTimesheetRequest(redirect, localStorage.getItem('access_token'))
      get(this.props, 'history').push('/time_sheet')
      this.props.setRedirect(false)
      return (<Redirect
        to={ {
          pathname: `/time_sheet/${this.state.activeTab === 3 ? 'status' : 'approval'}/${redirect}`,
          state: { activeTab: this.state.activeTab, header: 'Timesheet' },
        } }
      />)
    }
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    const redirectToLogin = get(this.props, 'redirectAuth.redirect')
    if (redirectToLogin) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <Manual
          isOpen={ get(this.props, 'isOpenManual') }
          closeManual={ this.props.closeManual }
        />
        <CustomModalMessage
          hide={ () => {
            this.props.hideConfirm(confirmType)
            if (confirmType === 'approveTimesheet') get(this.props, 'history').replace({ pathname: '/inbox', state: { header: 'My Inbox' } })
          } }
          show={
            confirmType === 'editTimesheet'
            || confirmType === 'submitTimesheet'
            || confirmType === 'discardTimesheet'
            || confirmType === 'approveTimesheet'
          }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        <AddProjectForm
          { ...this.state }
          open={ this.state.showAddProject }
          toggle={ this.addProject }
          handleCheckboxAddProject={ this.handleCheckboxAddProject }
          clickButtonAddProject={ this.clickButtonAddProject }
          clickRadioAddProject={ this.clickRadioAddProject }
          handleChangeSearch={ (e) => this.setState({ searchAddProject: e.target.value }) }
        />
        <CopyTimesheetForm
          { ...this.state }
          open={ this.state.showCopyTimesheet }
          toggle={ this.copyTimesheet }
          clickCopyButton={ this.clickCopyButton }
        />
        <SubmitTimesheetForm
          { ...this.state }
          open={ this.state.showSubmitRemark }
          submitMyTimesheet={ (type) => this.submitMyTimesheet(type) }
          handleSubmitRemark={ (e) => this.setState({ submitRemark: e.target.value }) }
        />
        <FillHoursForm
          open={ this.state.showFillHours }
          authData={ get(this.props, 'authData') }
          toggle={ () => this.setState({ showFillHours: !this.state.showFillHours }) }
          selectedDate={ this.state.selectedDate }
          myTimesheet={ this.state.myTimesheet }
          sumHoursByDate={ this.state.sumHoursByDate }
          maximumWorkingHoursPerDay={ this.state.maximumWorkingHoursPerDay }
          applyFillHours={ (projects) => this.applyFillHours(projects) }
        />
        <Tab
          { ...this.state }
          isFetching={ isFetching }
          authData={ get(this.props, 'authData') }
          toggleTab={ this.toggleTab }
          clickEdit={ this.clickEdit }
          clickCancel={ this.clickCancel }
          handleDiscard={ this.handleDiscard }
          handleDate={ this.handleDate }
          addProject={ this.addProject }
          copyTimesheet={ this.copyTimesheet }
          saveMyTimesheet={ this.saveMyTimesheet }
          submitMyTimesheet={ () => this.setState({ showSubmitRemark: true }) }
          fillHours={ () => this.setState({ showFillHours: !this.state.showFillHours }) }
          handleInputTimesheetByProjects={ this.handleInputTimesheetByProjects }
          handleInputTimesheetStatus={ this.handleInputTimesheetStatus }
          handleInputTimesheetApproval={ this.handleInputTimesheetApproval }
          location={ get(this.props, 'location.pathname') }
          path={ get(this.props, 'match.params.id') }
          approveTimesheet={ (requestID, payload) => this.props.approveTimesheet(requestID, payload, localStorage.getItem('access_token')) }
          cancelTimesheet={ (requestID, payload) => this.props.cancelTimesheet(requestID, payload, localStorage.getItem('access_token')) }
        />
        { !isFetching && (
          <Content
            { ...this.state }
            authData={ get(this.props, 'authData') }
            addTask={ this.addTask }
            deleteTask={ this.deleteTask }
            deleteProject={ this.deleteProject }
            clickEdit={ this.clickEdit }
            saveMyTimesheet={ this.saveMyTimesheet }
            clickCancel={ this.clickCancel }
            editHour={ this.editHour }
            handleDate={ this.handleDate }
            handleInputMyTimesheet={ this.handleInputMyTimesheet }
            calculateTotalHours={ this.calculateTotalHours }
            handleClickRequestRow={ (requestID) => this.props.setRedirect(requestID) }
            location={ get(this.props, 'location.pathname') }
            path={ get(this.props, 'match.params.id') }
            approveTimesheet={ (requestID, payload) => this.props.approveTimesheet(requestID, payload, localStorage.getItem('access_token')) }
          />
        )}
      </Wrapper>
    )
  }
}

TimeSheetPage.propTypes = {
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  getMyTimesheet: PropTypes.func.isRequired,
  getTimesheets: PropTypes.func.isRequired,
  editTimesheets: PropTypes.func.isRequired,
  setInvalidInput: PropTypes.func.isRequired,
  resetInvalidInput: PropTypes.func.isRequired,
  getTimesheetByProjects: PropTypes.func.isRequired,
  submitTimesheet: PropTypes.func.isRequired,
  getTimesheetStatus: PropTypes.func.isRequired,
  getTimesheetRequest: PropTypes.func.isRequired,
  setRedirect: PropTypes.func.isRequired,
  approveTimesheet: PropTypes.func.isRequired,
  cancelTimesheet: PropTypes.func.isRequired,
  confirmType: PropTypes.string,
  confirmStatus: PropTypes.any,
  confirmMessage: PropTypes.any,
  getLeaveType: PropTypes.func.isRequired,
  closeManual: PropTypes.func.isRequired,
}
TimeSheetPage.defaultProps = {
  confirmType: '',
  confirmStatus: '',
  confirmMessage: '',
  isFetching: false,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  isFetching: timesheetSelector.isFetching,
  getMyTimesheetData: timesheetSelector.getMyTimesheetData,
  getTimesheetsData: timesheetSelector.getTimesheetsData,
  editTimesheetsData: timesheetSelector.editTimesheetsData,
  getInvalidInputData: timesheetSelector.getInvalidInputData,
  getTimesheetByProjectsData: timesheetSelector.getTimesheetByProjectsData,
  submitTimesheetData: timesheetSelector.submitTimesheetData,
  getTimesheetStatusData: timesheetSelector.getTimesheetStatusData,
  getTimesheetRequestData: timesheetSelector.getTimesheetRequestData,
  setRedirectData: timesheetSelector.setRedirectData,
  approveTimesheetData: timesheetSelector.approveTimesheetData,
  cancelTimesheetData: timesheetSelector.cancelTimesheetData,
  getLeaveTypeData: leaveTypeSelector.getLeaveTypeData,
  isOpenManual: timesheetSelector.isOpenManual,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getMyTimesheet: timesheetAction.getMyTimesheet,
  resetGetMyTimesheet: timesheetAction.resetGetMyTimesheet,
  getTimesheets: timesheetAction.getTimesheets,
  resetGetTimesheets: timesheetAction.resetGetTimesheets,
  editTimesheets: timesheetAction.editTimesheets,
  resetEditTimesheets: timesheetAction.resetEditTimesheets,
  setInvalidInput: timesheetAction.setInvalidInput,
  resetInvalidInput: timesheetAction.resetInvalidInput,
  getTimesheetByProjects: timesheetAction.getTimesheetByProjects,
  resetGetTimesheetByProjects: timesheetAction.resetGetTimesheetByProjects,
  submitTimesheet: timesheetAction.submitTimesheet,
  resetSubmitTimesheet: timesheetAction.resetSubmitTimesheet,
  getTimesheetStatus: timesheetAction.getTimesheetStatus,
  resetGetTimesheetStatus: timesheetAction.resetGetTimesheetStatus,
  getTimesheetRequest: timesheetAction.getTimesheetRequest,
  resetGetTimesheetRequest: timesheetAction.resetGetTimesheetRequest,
  setRedirect: timesheetAction.setRedirect,
  approveTimesheet: timesheetAction.approveTimesheet,
  resetApproveTimesheet: timesheetAction.resetApproveTimesheet,
  cancelTimesheet: timesheetAction.cancelTimesheet,
  resetCancelTimesheet: timesheetAction.resetCancelTimesheet,
  getLeaveType: leaveTypeAction.getLeaveType,
  closeManual: timesheetAction.closeManual,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(TimeSheetPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/timesheet/index.js